import loadable from '@loadable/component';

export const UnpublishedOrgPageLoadable = loadable(
  () => import('./UnpublishedOrgPage'),
  { resolveComponent: (module) => module.UnpublishedOrgPage },
);
